<div class="top-menu hide-print">
  <div class="top-toolbar">
    <div class="d-flex flex-row justify-content-end align-items-stretch header-container">
      <div class="flex-40 flex-fill start-controls">
      </div>
      <div class="flex-60 flex-fill end-controls">
        <a *ngIf="loggedIn" [routerLink]="['/account/shipments']">
          <mat-icon fontSet="material-icons-outlined">local_shipping</mat-icon><span>Track your Order</span>
        </a>
        <a *ngIf="loggedIn" [routerLink]="['/account/loyalty']" class="d-none">
          <mat-icon fontSet="material-icons-outlined">redeem</mat-icon><span>Loyalty Points</span>
        </a>
        <a *ngIf="!loggedIn" [routerLink]="['/sign-in']">
          <mat-icon fontSet="material-icons-outlined">manage_accounts</mat-icon><span>Register or Sign In</span>
        </a>
        <a *ngIf="loggedIn" [matMenuTriggerFor]="accountMenu">
          <mat-icon fontSet="material-icons-outlined">manage_accounts</mat-icon>
          <span *ngIf="!customer.firstName">My Account</span>
          <span *ngIf="customer.firstName">Hi {{customer.firstName}}</span>
        </a>
      </div>
    </div>
  </div>
  <div class="d-flex flex-row flex-wrap logo-toolbar justify-content-center align-items-stretch" [style.overflow]="menuOverflow" [style.position]="menuPosition" [style.background]="menuBackground" [style.top]="menuPosition === 'fixed'? '0': 'unset'">
    <div class="flex-10">
      <a routerLink="/" class="d-none d-md-block logo-link">
        <img src="assets/images/logo/logo-small.webp" alt="Meinl Sonic Energy" class="logo" />
      </a>
    </div>
    <div [class]="menuPosition === 'fixed'? 'flex-80 top-menu-dark': 'flex-80 top-menu-light'">
      <app-menu></app-menu>
    </div>
    <div [class]="menuPosition === 'fixed'? 'flex-10 top-menu-dark': 'flex-10 top-menu-light'">
      <div class="right-controls flex-100 d-flex flex-row flex-wrap justify-content-center align-items-center">
        <div class="flex-50 d-flex flex-row flex-wrap justify-content-center align-items-center">
          <div class="flex-20 spacer">
            <span class="text-accent" style="font-size:24px;">|</span>
          </div>
          <div class="flex-80 search">
            <a mat-button [routerLink]="['/search']" name="search" title="search">
              <mat-icon class="icon-15" color="accent">search</mat-icon>
            </a>
          </div>
        </div>
        <div class="flex-50 mini-cart d-flex flex-row flex-wrap justify-content-center align-items-center">
          <button [matMenuTriggerFor]="cartMenu" #cartMenuTrigger="matMenuTrigger" aria-label="Shopping Cart" title="Shopping Cart" name="Shopping Cart" title="Shopping Cart" *ngIf="customer?.totalCartCount > 0" mat-icon-button class="flex-auto flex-row-button" style="position: relative;">
            <mat-icon [matBadge]="customer?.totalCartCount" matBadgeSize="medium" color="accent" matBadgeColor="primary">shopping_cart</mat-icon>
            <div class="flex-auto cart-total">{{customer?.orderTotals?.orderTotalDisplay}}</div>
          </button>
          <button [matMenuTriggerFor]="cartMenu" #cartMenuTrigger="matMenuTrigger" aria-label="Shopping Cart" title="Shopping Cart" name="Shopping Cart" *ngIf="!customer || customer?.totalCartCount === 0" mat-icon-button class="flex-auto flex-row-button">
            <mat-icon class="cart-icon" color="accent">shopping_cart</mat-icon>
          </button>
        </div>
      </div>
      <div class="justify-content-center align-items-center desktop">
        <mat-menu #cartMenu="matMenu" [overlapTrigger]="false" xPosition="before" class="top-menu-dropdown cart-dropdown" aria-label="Shopping Cart">
          <div *ngIf="customer?.totalCartCount === 0 || !customer" class="py-1"><span>You have no items in your shopping cart.</span></div>
          <div *ngIf="customer?.updatingCart" class="updating-cart">
            <span class="highlight-colour font-small">
              Updating cart with current stock and prices
            </span>
          </div>
          <div *ngIf="customer?.totalCartCount > 0" class="d-flex flex-row mb-2 justify-content-between align-items-center">
            <span>{{customer && customer?.totalCartCount}} Item<span *ngIf="customer?.totalCartCount > 1">s</span></span>
            <a [routerLink]="['/cart']" mat-raised-button color="accent" matTooltip="View and edit cart contents"><span class="fw-700">View Cart</span></a>
          </div>
          <div *ngFor="let product of customer?.cartList" class="flex-100 d-flex flex-row flex-wrap py-1">
            <div class="flex-70">
              <a class="product-click font-small" (click)="productClick(product)">{{product?.name}}</a>
            </div>
            <div class="flex-30 text-right font-small">
              {{product?.cartCount}} x {{product?.valuePriceDisplay}}
            </div>
          </div>
          <div *ngIf="customer?.cartList?.length > 0 && customer?.selectedShippingType" class="cart-dropdown-footer">
            <div class="d-flex flex-row mt-1 justify-content-between align-items-center font-small">
              <b>Est. Shipping:</b>
              <b class="new-price" *ngIf="customer?.selectedShippingType?.rate">{{customer?.selectedShippingType?.rateDisplay}}</b>
              <b class="new-price" *ngIf="customer?.selectedShippingType?.rate === 0">FREE</b>
            </div>
          </div>
          <div *ngIf="customer?.cartList?.length > 0" class="cart-dropdown-footer">
            <div class="divider mt-1"></div>
            <div class="d-flex flex-row mt-1 justify-content-between align-items-center font-small">
              <b>TOTAL:</b>
              <b class="new-price">{{customer?.orderTotals?.orderTotalDisplay}}</b>
            </div>
            <div class="text-center mt-1 mb-1" *ngIf="spendMore()">
              <a [routerLink]="['/']" routerLinkActive="router-link-active" class="highlight-colour">
                {{spendMore()}}
              </a>
            </div>
            <div class="d-flex flex-row mt-1 justify-content-between align-items-center">
              <a [routerLink]="['/checkout']" mat-raised-button color="primary" matTooltip="Go straight to the Checkout" matTooltipPosition="below" class="checkout-button">
                <mat-icon>add_shopping_cart</mat-icon>
                <span class="fw-700">Checkout</span>
              </a>
            </div>
          </div>
        </mat-menu>
      </div>
    </div>
  </div>
</div>
<mat-menu #accountMenu [overlapTrigger]="false" xPosition="before" yPosition="above" [aria-label]="'My Account'">
  <div *ngFor="let section of settings.accountLinks" class="account-section">
    <div *ngIf="!section?.children?.length">
      <a [routerLink]="section.routerLink" routerLinkActive="horizontal-active-link" [routerLinkActiveOptions]="{exact:true}" class="account-section-title">{{section.name}}</a>
    </div>
    <div *ngIf="section?.children?.length > 0">
      <span class="account-section-title">{{section.name}}</span>
      <mat-list-item *ngFor="let link of section.children">
        <a matLine [routerLink]="link.routerLink" routerLinkActive="horizontal-active-link" [routerLinkActiveOptions]="{exact:true}">{{ link.name }}</a>
      </mat-list-item>
    </div>
  </div>
</mat-menu>
